import { Container } from './style';

export function DeletingLoader() {
  return <Container />
}
